'use strict';
var $ = require('../internals/export');
var forEach = require('../internals/array-for-each');

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.array.for-each.js
// module id = 45
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 13 14 16 17 18 19 20 22 23 24 26 27 28 29 30 31 32 34 35 39 43 44 46 47